import React from "react";
import RolePermissionBuildingBlock from "./RolePermissionBuildingBlock";
import s from './RolePermissionBlock.module.scss';

const RolePermissionBlock = ({ permission, callBack, permissionTagList }) => {
    // console.log('permission', permission)
    return (
        <div className={s.container}>
            <div className={s.header}>
                <RolePermissionBuildingBlock title={permission.displayName} type={"uiPermissionTags"} callBack={callBack} tag={permission.uiPermission} permissionTagList={permissionTagList} />
            </div>
            <div className={s.apiPermissions}>
                {
                    permission.apiPermissions?.map((apiPermission, index) => {
                        return (
                            <RolePermissionBuildingBlock title={apiPermission} type={"apiPermissionTags"} callBack={callBack} key={index} tag={apiPermission} permissionTagList={permissionTagList} />
                        )
                    })
                }
            </div>
        </div>

    )
}

export default React.memo(RolePermissionBlock);